export default function ContactHead({ locale }: { locale: string }) {
  return (
    <div>
      <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
        {locale === "en" ? "Let’s Build a" : "لننشئ"}{" "}
        <span className="bg-linear-to-r text-[#c9a24d]">
          {locale === "en" ? "Smarter ERP" : "نظام ERP أذكى"}
        </span>{" "}
        {locale === "en" ? "for Your Business" : "لعملك"}
      </h2>

      <p className="text-lg text-muted-foreground max-w-xl">
        {locale === "en"
          ? "Talk to our consultants about ERP implementation, business process optimization, and long-term system scalability."
          : "تحدث إلى مستشارينا حول تنفيذ نظام ERP، وتحسين عمليات الأعمال، وقابلية التوسع على المدى الطويل."}
      </p>
    </div>
  );
}
